import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Layout from "../components/Layout";
import TripList from "../components/TripList";

const Dashboard = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      alert("Please Login！");
      navigate("/");
    }
  }, [navigate]);

  return (
    <Layout>
      <div className="max-w-4xl mx-auto bg-white shadow-md rounded-lg p-4 sm:p-6 responsive-container">
		<h1 className="text-2xl sm:text-4xl font-extrabold text-primary mb-4 text-center sm:text-left">
		  Organize Your Next Adventure
		</h1>
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3 mb-4">
          <h2 className="text-lg sm:text-2xl font-bold leading-snug">Plan your dream trips with ease and spark unforgettable journeys.</h2>
			<button
			  onClick={() => navigate("/create-trip")}
			  className="bg-primary text-white px-4 py-2 rounded-lg hover:bg-orange-600 w-full sm:w-auto"
			>
			  + Plan New Trip
			</button>
        </div>

        <TripList />
      </div>
    </Layout>
  );
};

export default Dashboard;
